import { PostStatus } from '../constants';

const statusesWithoutReactions = [PostStatus.DRAFT, PostStatus.DECLINED, PostStatus.MODERATION];

export const isPostStatusValidForReaction = (status: PostStatus) =>
    !statusesWithoutReactions.includes(status);
